import React from 'react';
import techtopLogoIcon from '../../images/techtop-full-logo.svg';
import { STATIC_FILES_URL } from '../../constants';
import PalletService from '../../services/PalletService/PalletService';
import Loader from '../../components/Loader/Loader';
import * as XLSX from 'xlsx';
import moment from 'moment';

class PrintLabel extends React.Component {
    constructor(props) {
        super(props);
        this.modelInputRef = React.createRef();
        this.state = {
            model: '',
            quantity: '',
            showPreview: false,
            modelData: [],
            errorMessage: '',
            showLoader: 0
        };

        this.handleBarcodeScan = this.handleBarcodeScan.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.printLabel = this.printLabel.bind(this);
        this.palletService = new PalletService();
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleBarcodeScan);
        this.getExcelData();

        if (this.modelInputRef.current) {
            this.modelInputRef.current.focus();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleBarcodeScan);
    }

    getExcelData() {
        fetch(`${STATIC_FILES_URL}/model-pallets.xlsx`)
        .then(res => res.arrayBuffer())
        .then(data => {
            const workbook = XLSX.read(data, { type: 'array' });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const json = XLSX.utils.sheet_to_json(sheet);
            this.setState({ modelData: json });
        });
    }

    setModelAndQuantity(scannedModel) {
        const { modelData } = this.state;
        
        const matched = modelData.find(
            item => item.Model === scannedModel
        );

        if (!matched) {
            this.setState({
                model: '',
                quantity: '',
                showPreview: false,
                errorMessage: 'Model not found in data.'
            });
            return;
        }

        this.setState({
            model: scannedModel,
            quantity: matched ? matched['Pallet Load'] : '',
            showPreview: true,
            errorMessage: ''
        });
    }


    // Handles REAL barcode scanner input (keyboard emulation)
    handleBarcodeScan(e) {
        // initialize buffer once
        if (!this.scanBuffer) {
            this.scanBuffer = '';
        }

        // scanner finished → Enter key
        if (e.key === 'Enter') {
            if (this.scanBuffer.length > 3) {
                this.setModelAndQuantity(this.scanBuffer);
            }

            // clear buffer AFTER processing
            this.scanBuffer = '';
            return;
        }

        // collect characters
        if (e.key.length === 1) {
            this.scanBuffer += e.key;
        }
    }

    handleChange(e) {
        const { name, value } = e.target;

        if (name === 'quantity') {
            this.setState({ quantity: value });
        }
        
        if (name === 'model') {
            this.setState({ model: value });
        }
    }


    printLabel(e) {
        e.preventDefault();

        const payload = {
            model: this.state.model,
            quantity: this.state.quantity
        };

        this.exportNetpricePdf();
    }

    async exportNetpricePdf() {
        const { model, quantity } = this.state;
        this.setState({ showLoader: 1 });
        try {
            this.palletService.exportPalletLabelPdf(model, quantity).then((response) => {
                const blob = response.data; // Already a Blob object
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                const formattedDate = moment().format('MM-DD-YYYY_HH-mm'); // Safe for filenames
                const title = `${model}-pallet-label-${formattedDate}`;
                link.href = url;
                link.download = `${title}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.setState({ showLoader: 0 });
            }).catch((error) => {
                console.error('Error downloading file:', error);
                this.setState({ showLoader: 0 });
            });
        } catch (error) {
            console.error('Error downloading pallet label pdf:', error);
            this.setState({ showLoader: 0 });
        }
    }

    render() {
        const { model, quantity, showPreview, errorMessage, showLoader} = this.state;

        return (
            <main role="main" className="middle-content-area">
                <section className="tracking-section">
                    <div className="container mb-5">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="default-title">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h1 className="m-0 color1"> Print Pallet Label</h1>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center offset-lg-1 col-xl-10 offset-xl-1 mb-5 mt-5">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                                <div className="common-width-div border p-4 rounded">
                                    {errorMessage && (
                                        <div className="alert alert-danger" role="alert">
                                            {errorMessage}
                                        </div>
                                    )}
                                    {/* Quantity */}
                                    <div className="form-group mb-3">
                                        <label>Custom Quantity</label>
                                        <input
                                            type="number"
                                            name="quantity"
                                            className="form-control"
                                            value={quantity}
                                            onChange={this.handleChange}
                                            placeholder="Enter Quantity"
                                            onBlur={() => {
                                                if (!this.state.quantity && this.state.model) {
                                                    const matched = this.state.modelData.find(
                                                        item => item.Model === this.state.model
                                                    );
                                                    if (matched) {
                                                        this.setState({ quantity: matched['Pallet Load'] });
                                                    }
                                                }
                                            }}
                                        />
                                    </div>

                                    {/* Model (Scanned only) */}
                                    <div className="form-group mb-3">
                                        <label>Model (Scanned)</label>
                                        <input
                                            type="text"
                                            name="model"
                                            className="form-control"
                                            value={model}
                                            ref={this.modelInputRef}
                                            onChange={this.handleChange}
                                            placeholder="Scan barcode"
                                        />
                                    </div>

                                    {/* DEV ONLY: Manual barcode input */}
                                    {/* <input
                                        type="text"
                                        className="form-control"
                                        placeholder="DEV: paste barcode & press Enter"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && e.target.value) {
                                                this.setModelAndQuantity(e.target.value);
                                                e.target.value = '';
                                            }
                                        }}
                                    /> */}
                                </div>
                            </div>
                            <div  className="col-12 col-sm-6 col-md-6 col-lg-6">
                                {/* Preview — visible ONLY after scan */}
                                {showPreview && (
                                    <div className="row justify-content-center">
                                        <div className="">
                                            <div className="text-center mb-3">
                                                <h4>Pallet Label Preview</h4>
                                            </div>
                                            <div
                                                className="border p-3"
                                                style={{ width: '400px', margin: 'auto' }}
                                            >
                                                <img
                                                    src={techtopLogoIcon}
                                                    alt="Techtop Logo"
                                                    style={{ maxWidth: '180px', marginBottom: '10px' }}
                                                />

                                                <table className="table table-bordered mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>Model</strong></td>
                                                            <td>{model}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Quantity</strong></td>
                                                            <td>{quantity || '-'}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="text-center mt-3">
                                            {/* Print Button */}
                                            <button
                                                className="btn track-shipment-btn"
                                                disabled={!model}
                                                onClick={this.printLabel}
                                            >
                                                Print Label
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                <Loader isLoading={showLoader} message="Processing..."/>
            </main>
        );
    }
}

export default PrintLabel;